function initAnimations(context = document) {
  const sections = context.querySelectorAll('.animate-wrapper');

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
          obs.unobserve(entry.target); // animate only once
        }
      });
    }, { threshold: 0.2 });

    sections.forEach(section => observer.observe(section));
  } else {
    // fallback for older browsers
    sections.forEach(section => section.classList.add('active'));
  }
}

// Run on initial page load
document.addEventListener('DOMContentLoaded', () => {
  initAnimations();
});

// Run on Shopify theme editor section load
document.addEventListener('shopify:section:load', (event) => {
  initAnimations(event.target);
});



